import { ChevronRight } from "lucide-react";
import { APP_PRICING_URL } from "@/lib/appUrls";

export const PricingStrip = () => {
  return (
    <section className="py-16 sm:py-20 bg-gray-900">
      <div className="max-w-3xl mx-auto px-4 text-center space-y-6">
        <h2 className="text-3xl sm:text-4xl font-bold text-white">
          $20 a month. Everything included.
        </h2>
        <p className="text-lg text-gray-300">
          Unlimited photos, members, and projects. One missing photo can cost you
          more than a year of Property Vue. One price, no tiers, no add-ons.
        </p>
        <a
          href={APP_PRICING_URL}
          className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary text-white font-semibold rounded-lg transition-all duration-300 hover:bg-primary/90"
        >
          Get started
          <ChevronRight size={20} />
        </a>
      </div>
    </section>
  );
};
